import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { starFillIcon, starOutlineIcon } from "./Icons";

function CollectionButton({ materialId }) {
  const { collection, changeCollection } = useContext(UserContext);

  return (
    <div onClick={() => changeCollection(materialId)}>
      {collection.includes(materialId) ? starFillIcon : starOutlineIcon}
    </div>
  );
}

export default CollectionButton;
